import Badge from "./badge";
import type { Anomaly } from "@/hooks/use-anomalies";

interface Props {
  anomalies: Anomaly[];
}

// Compact badge that renders only when anomalies exist. Picks worst severity
// (error > warn) for color; tooltip lists each anomaly so operator can hover
// for detail without opening the detail page.
export default function AnomalyBadge({ anomalies }: Props) {
  if (!anomalies || anomalies.length === 0) return null;

  const hasError = anomalies.some(a => a.severity === "error");
  const color = hasError ? "danger" : "warn";
  const icon = hasError ? "!" : "⚠";
  const tooltip = anomalies
    .map(a => `[${a.severity.toUpperCase()}] ${a.message}`)
    .join("\n");

  return (
    <Badge color={color} title={tooltip}>
      {icon} {anomalies.length}
    </Badge>
  );
}
